module.exports = __webpack_public_path__ + "static/media/badge2.eb5597dc.svg";